import {Button, ButtonGroup} from "@mui/material";
import {Link} from "react-router-dom";

function SignButtons({alert = ''}) {
    return <ButtonGroup>
        <Link to={"/login"}><Button color={"primary"} variant={"outlined"}>Zaloguj</Button></Link>
        <Link to={"/register"}><Button color={"primary"} variant={"contained"}>Rejestracja</Button></Link>
    </ButtonGroup>;

}

export default SignButtons;